import NewBookingFlightList from "./NewBookingFlightList";

export default NewBookingFlightList;
